import { Pipe, PipeTransform } from '@angular/core';

/*
 * Format the Guardian Name to be used in templates if the First and Last name are not null
 * Takes an index of the Guardian in the array to append to the name
 * Usage:
 *   value | fullName:currentIdx
 * Example:
 *   {{ guardian |  fullName:1}}
 *   formats to: Susy Test or Guardian 1 if first or last name were null
 */

@Pipe({
    name: 'fullName',
    standalone: true
})
export class FullNamePipe implements PipeTransform {
	transform(value: any, currentIdx: number): string {
		if (value && value.firstName && value.lastName) {
			if (value.firstName.trim() !== '' && value.lastName.trim() !== '') {
				return value.firstName + ' ' + value.lastName;
			}
		}
		// If birthdate is present on the object, it means we have a child
		// Otherwise it is a guardian object
		if (value.birthdate !== undefined) {
			if (currentIdx !== null) {
				return 'Child ' + (currentIdx + 1);
			} else {
				return 'Child';
			}
		} else {
			if (currentIdx !== null) {
				return 'Parent/Guardian ' + (currentIdx + 1);
			} else {
				return 'Parent/Guardian';
			}
		}
	}
}
